(function () {
  const DESKTOP = window.matchMedia('(min-width: 1200px)');

  function initNav(root) {
    if (!root || root.dataset.lbpInit) return;
    root.dataset.lbpInit = '1';

    const items = [...root.querySelectorAll('.lbp-nav__item--has-panel')];
    let openItem = null;
    let closeTimer = null;
    let openTimer = null;

    function closeAll() {
      items.forEach((item) => {
        item.classList.remove('lbp-nav__item--open');
        const panel = item.querySelector('.lbp-nav__panel');
        const btn = item.querySelector('.lbp-nav__toggle');
        if (panel) panel.hidden = true;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      openItem = null;
    }

    function openItemPanel(item) {
      if (openItem === item) return;
      closeAll();
      item.classList.add('lbp-nav__item--open');
      const panel = item.querySelector('.lbp-nav__panel');
      const btn = item.querySelector('.lbp-nav__toggle');
      if (panel) panel.hidden = false;
      if (btn) btn.setAttribute('aria-expanded', 'true');
      openItem = item;
    }

    items.forEach((item) => {
      const btn = item.querySelector('.lbp-nav__toggle');
      const l1 = item.querySelector('.lbp-nav__l1');

      item.addEventListener('mouseenter', () => {
        if (!DESKTOP.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => openItemPanel(item), openItem ? 0 : 110);
      });

      item.addEventListener('mouseleave', () => {
        if (!DESKTOP.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(closeAll, 190);
      });

      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.classList.contains('lbp-nav__item--open')) closeAll();
          else openItemPanel(item);
        });
      }

      if (l1) {
        l1.addEventListener('focus', () => {
          if (DESKTOP.matches) openItemPanel(item);
        });
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    DESKTOP.addEventListener('change', () => closeAll());
  }

  function boot() {
    document.querySelectorAll('.lbp-nav').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
